<template>
  <div v-if="isLoading || companies.length > 0" class="interested-companies">
    <template v-if="isLoading">
      <div class="interested-companies-loading">
        <div v-for="n in 5" :key="n" class="interested-companies-loading__card" />
      </div>
    </template>
    <template v-else>
      <h2 class="interested-companies__title">
        {{ companyName }}に興味を持っている他のワンキャリア会員は、このような企業も見ています
      </h2>
      <div ref="carousel" class="interested-companies__list">
        <InterestedCompanyCard
          v-for="company in companies"
          :key="company.id"
          :company="company"
          @toggle-follow="handleToggleFollow"
        />
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import InterestedCompanyCard from './components/InterestedCompanyCard';
import { fetchInterestedCompanies } from 'oc2api/interested_companies';

const PREV_ARROW =
  '<button type="button" class="interested-companies__arrow interested-companies__arrow--prev" aria-label="前へ"></button>';
const NEXT_ARROW =
  '<button type="button" class="interested-companies__arrow interested-companies__arrow--next" aria-label="次へ"></button>';

export default {
  name: 'InterestedCompanies',
  components: { InterestedCompanyCard },
  props: {
    companyName: {
      type: String,
      required: true,
    },
    companyId: {
      type: Number,
      required: true,
    },
    loginPath: {
      type: String,
      default: '/users/sign_in',
    },
  },
  data() {
    return {
      companies: [],
      isLoading: false,
      slickInitialized: false,
    };
  },
  async created() {
    this.isLoading = true;
    const data = await fetchInterestedCompanies(this.companyId);
    this.isLoading = false;
    this.companies = data;
    if (data.length > 0) {
      await this.$nextTick();
      this.initSlick();
    }
  },
  beforeDestroy() {
    if (this.slickInitialized && this.$refs.carousel) {
      window.$(this.$refs.carousel).slick('unslick');
      this.slickInitialized = false;
    }
  },
  methods: {
    initSlick() {
      if (this.slickInitialized || !this.$refs.carousel) return;
      window.$(this.$refs.carousel).slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: PREV_ARROW,
        nextArrow: NEXT_ARROW,
        infinite: false,
        dots: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      });
      this.slickInitialized = true;
    },
    async handleToggleFollow({ companyId, following }) {
      const target = this.companies.find((c) => c.id === companyId);
      if (!target) return;

      // 楽観的更新
      target.following = !following;

      try {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
        const config = { headers: { 'X-CSRF-Token': csrfToken } };

        if (following) {
          await axios.delete(`/api/v3/companies/${companyId}/like`, config);
        } else {
          await axios.post(`/api/v3/companies/${companyId}/like`, {}, config);
        }
      } catch (err) {
        if (err.response?.status === 401) {
          window.location.href = this.loginPath;
          return;
        }
        // エラー時はロールバック
        target.following = following;
      }
    },
  },
};
</script>

<style scoped>
.interested-companies {
  margin: 24px 0;
}

.interested-companies__title {
  font-weight: 400;
  font-size: 20px;
  color: #053053;
  padding-bottom: 12px;
  margin-top: 64px;
  margin-bottom: 16px;
}
</style>

<!-- slick が Vue の外側に挿入するボタン要素のため非スコープで記述 -->
<style lang="scss">
.interested-companies__arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  width: 32px;
  height: 32px;
  background: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  @media screen and (max-width: 768px) {
    display: none !important;
  }
}

.interested-companies__arrow::before {
  content: '';
  display: block;
  width: 8px;
  height: 8px;
  border-top: 2px solid #333;
  border-right: 2px solid #333;
}

.interested-companies__arrow--prev {
  left: 4px;
}

.interested-companies__arrow--prev::before {
  transform: rotate(-135deg) translate(-1px, 1px);
}

.interested-companies__arrow--next {
  right: 4px;
}

.interested-companies__arrow--next::before {
  transform: rotate(45deg) translate(-1px, 1px);
}

.interested-companies__arrow.slick-disabled {
  opacity: 0.3;
  cursor: default;
  pointer-events: none;
}

.interested-companies__arrow.slick-hidden {
  display: none;
}
</style>
